var $a58a7ab9570c5a18$exports = {};
$a58a7ab9570c5a18$exports = {
    "(optional)": `(\u{C120}\u{D0DD} \u{C0AC}\u{D56D})`,
    "(required)": `(\u{D544}\u{C218} \u{C0AC}\u{D56D})`
};


export {$a58a7ab9570c5a18$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
